export function hasClass(el, className) {
    if (!el) {
        return false;
    }
    if (el.classList) {
        return Array.prototype.some.call(el.classList, item => item === className)
    } else {
        const orgClassName = el.className && typeof el.className === 'object' ? el.getAttribute('class') : el.className
        return orgClassName && !!orgClassName.match(new RegExp('(\\s|^)' + className + '(\\s|$)'))
    }
}

export function addClass(el, className) {
    if (!el) {
        return;
    }

    if (el.classList) {
        className.replace(/(^\s+|\s+$)/g, '').split(/\s+/g).forEach(item => {
            item && el.classList.add(item)
        })
    } else if (!hasClass(el, className)) {
        if (el.className && typeof el.className === 'object') {
            el.setAttribute('class', el.getAttribute('class') + ' ' + className)
        } else {
            el.className += ' ' + className
        }
    }
}
export function removeClass(el, className) {
    if (!el) {
        return;
    }
    if (el.classList) {
        className.split(/\s+/g).forEach(item => {
            el.classList.remove(item)
        })
    } else if (hasClass(el, className)) {
        className.split(/\s+/g).forEach(item => {
            let reg = new RegExp('(\\s|^)' + item + '(\\s|$)')
            if (el.className && typeof el.className === 'object') {
                el.setAttribute('class', el.getAttribute('class').replace(reg, ' '))
            } else {
                el.className = el.className.replace(reg, ' ')
            }
        })
    }
}

export function findIndexByTime(currentTime, list, index) {
    const len = list.length
    if (len < 1) {
        return -1
    }
    index = index < 0 ? 0 : (index >= len ? len - 1 : index)
    if (list[index].start <= currentTime && currentTime < list[index].end) {
        return index
    } else {
        let i = list[index].end <= currentTime ? index + 1 : 0
        for (; i < len; i++) {
            if (list[i].start <= currentTime && currentTime < list[i].end) {
                return i
            } else if (currentTime > list[i].end && i + 1 < len && currentTime <  list[i+1].start) {
                return -1
            } else if (currentTime > list[i].end && i + 1 >= len ){
                return -1
            }
        }
        return -1
    }
}


export function typeOf(obj) {
    return Object.prototype.toString.call(obj).match(/([^\s.*]+)(?=]$)/g)[0]
}

export function isMobile () {
    let ua = navigator.userAgent
    let isWindowsPhone = /(?:Windows Phone)/.test(ua)
    let isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone
    let isAndroid = /(?:Android)/.test(ua)
    let isFireFox = /(?:Firefox)/.test(ua)
    let isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua))
    let isPhone = /(?:iPhone)/.test(ua) && !isTablet
    return isPhone || isAndroid || isSymbian || isTablet
}